import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import SecureAcquisitionPortal from "./sections/SecureAcquisitionPortal";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <SecureAcquisitionPortal />
      <ContactInformation />
      <Footer />
    </div>;
}